
export default {
  props: {
    label: {
      type: String,
      required: false,
      default: 'Terug naar overzicht',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
